<h2>Select a station</h2>

<div class="grid col-12 justify-content-evenly">
  @for (station of stations; track station.Id) {
  <div class="col-12 sm:col-6 lg:col-12 xl:col-3 p-2" (click)="onStationClick(station)">
    <div class="p-4 border-1 surface-border surface-card border-round pointer" [ngClass]="{'selected': selectedStation?.Id === station.Id}">
      <div class="flex flex-column align-items-center gap-3 py-5">
        <img class="w-9 shadow-2 border-round" [src]="station.Topic | stationImage" [alt]="station.Name" />
        <div class="text-2xl font-bold">{{station.Name}}</div>
        <p>{{station.WebDescription}}</p>
      </div>
    </div>
  </div>
  }
  @empty {
  <div class="col-12 sm:col-6 lg:col-12 xl:col-3 p-2">No stations found.</div>
  }
</div>
@if (isLoading()) {
<div class="progress-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}

<div class="flex justify-content-between mt-1 w-full">
  <p-button [routerLink]="['/', routes.STATIONS, routes.GROUPS]" label="BACK"></p-button>
  <p-button [routerLink]="['/', routes.STATIONS, routes.GROUPS, selectedGroup?.Id]" [disabled]="!selectedStation" label="NEXT"></p-button>
</div>